<template>
  <div class="pagination_container" :class="[commonWidth, commonSpacing, paginationContainer]" v-if="this.listData.total > 0">
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="listData.pageindex"
      :page-size="listData.rows"
      :total="listData.total"
      :pager-count="listData.pageCount"
      @current-change="changecurrentPage"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    pageindex:{
      type: Number,
      default: 1
    },
    rows:{
      type: Number,
      default: 6
    },
    total:{
      type: Number,
      default: 0
    },
    pageCount: {
      type: Number,
      default: 0
    }
  },
  computed:{
    commonWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 'mwidth'
        case "sm":
          return 'mwidth'
        case "md":
          return 'pcwidth'
        case "lg":
          return 'pcwidth'
        case "xl":
          return 'pcwidth'
      }
    },
    commonSpacing() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "mspacing";
        case "sm":
          return "mspacing";
        case "md":
          return "pcspacing";
        case "lg":
          return "pcspacing";
        case "xl":
          return "pcspacing";
      }
    },
    paginationContainer(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "mpaginationContainer";
        case "sm":
          return "mpaginationContainer";
        case "md":
          return "pcpaginationContainer";
        case "lg":
          return "pcpaginationContainer";
        case "xl":
          return "pcpaginationContainer";
      }
    },
    font20() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m20";
        case "sm":
          return "m20";
        case "md":
          return "p20";
        case "lg":
          return "p20";
        case "xl":
          return "p20";
      }
    },
    font16(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m16";
        case "sm":
          return "m16";
        case "md":
          return "p16";
        case "lg":
          return "p16";
        case "xl":
          return "p16";
      }
    }
  },
  watch: {
    pageindex() {
      this.listData.pageindex = this.pageindex
    },
    rows() {
      this.listData.rows = this.rows
    },
    total(){
      this.listData.total = this.total
      this.listData.pageCount = this.pageCount ? this.pageCount : parseInt( this.listData.total / this.listData.rows )
    }
  },
  data() {
    return {
      listData: {
        pageindex: 0,
        rows: 6,
        total: 0,
        pageCount: 0
      }
    }
  },
  mounted () {
    this.listData.total = this.total
    this.listData.rows = this.rows
  },
  methods: {
    changecurrentPage(val){
      this.listData.pageindex = parseInt(val);
      this.$emit('handle-changepage', val)
    }
  },
};
</script>

<style lang="scss">
  .pagination_container{
    .el-pagination {
      width: 100%;
      overflow-x:auto;
      text-align: center;
    }
    .el-pager{
      li{
        background: #fff;
        color: #9698a0!important;
        border-radius: 2px;
      }
      li.active{
        background: #122266!important;
        color: #fff!important;
      }
      li.active:hover{
        color: #fff!important;
      }
      li:hover{
        color: #9698a0!important;
      }
    }
  }
  .pcpaginationContainer{
    .el-pagination {
      padding: 40px 0 60px;
    }
    .btn-prev{
      min-width: 48px!important;
      min-height: 48px!important;
    }
    .btn-next{
      min-width: 48px!important;
      min-height: 48px!important;
    }
    .el-pager{
      .more::before{
        line-height: 48px;
      }
      li{
        min-width: 48px!important;
        min-height: 48px!important;
        line-height: 48px;
      }
    }
  }
  .mpaginationContainer{
    .el-pagination {
      padding: 20px 0 30px;
    }
    .btn-prev{
      min-width: 30px!important;
      min-height: 30px!important;
    }
    .btn-next{
      min-width: 30px!important;
      min-height: 30px!important;
    }
    .el-pager{
      .more::before{
        line-height: 30px;
      }
      li{
        min-width: 30px!important;
        min-height: 30px!important;
        line-height: 30px;
      }
    }
  }
</style>
